// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"114":"f3b9e8aec21c151679c5","826":"b39d6549c35c24123adc"}[chunkId] + ".js";
};